/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_SubmittedInputs */

const en_directory_submit_review_submitted = /** @type {(inputs: Directory_Submit_Review_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted for review!`)
};

const zh_directory_submit_review_submitted = /** @type {(inputs: Directory_Submit_Review_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已提交审核！`)
};

/**
* | output |
* | --- |
* | "Submitted for review!" |
*
* @param {Directory_Submit_Review_SubmittedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_submitted = /** @type {((inputs?: Directory_Submit_Review_SubmittedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_SubmittedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_submitted(inputs)
	return zh_directory_submit_review_submitted(inputs)
});
export { directory_submit_review_submitted as "directory.submit.review.submitted" }